export default function getAutoTag({ autoTag, gaLabel, itemKey }, prefix) {
  return autoTag || gaLabel || `${prefix}_${itemKey}`;
}
